import React from 'react'
import Image from 'next/image'
const AppStoreBadgePC = (props) => {
  return (
    <a
      href="https://apps.apple.com/us/app/orka-health/id1525826891"
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      <img
        alt="Get it on App Store"
        src={'/imgs/Landing/appleBadge.svg'}
        style={{
          height: '100%'
        }}
      />
    </a>
  )
}

const GooglePlayBadgePC = (props) => {
  return (
    <a
      href="https://play.google.com/store/apps/details?id=com.hiorka.orka&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      <Image
        width={216}
        height={64}
        alt="Get it on Google Play"
        src={'/imgs/Landing/googleBadge.jpg'}
        key={'/imgs/Landing/googleBadge.jpg'}
        style={{
          height: '100%',
          width: 'auto'
        }}
        unoptimized
      />
    </a>
  )
}

const GooglePlayBadgeMobile = (props) => (
  <a
    href="https://play.google.com/store/apps/details?id=com.hiorka.orka&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    target="_blank"
    rel="noreferrer"
    {...props}
  >
    <Image
      width={114}
      height={34}
      alt="Get it on Google Play"
      src={'/imgs/Landing/googleBadge.jpg'}
      style={{
        height: '100%',
        objectFit: 'contain'
      }}
    />
  </a>
)

const AppStoreBadgeMobile = (props) => (
  <a
    href="https://apps.apple.com/us/app/orka-health/id1525826891"
    target="_blank"
    rel="noreferrer"
    {...props}
  >
    <Image
      width={114}
      height={34}
      alt="Get it on App Store"
      src={'/imgs/Landing/appleBadge.svg'}
      style={{
        height: '100%',
        objectFit: 'contain'
      }}
    />
  </a>
)

export {
  AppStoreBadgePC,
  GooglePlayBadgePC,
  AppStoreBadgeMobile,
  GooglePlayBadgeMobile
}
